import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-purple-900 text-white pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <p className="mb-4 text-gray-300">
              Professional pool cleaning and maintenance services in Central Florida.
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://facebook.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-orange-400 transition-colors duration-200"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://instagram.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-orange-400 transition-colors duration-200"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-300 hover:text-orange-400 transition-colors duration-200"
              >
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Home</Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Services</Link>
              </li>
              <li>
                <Link to="/testimonials" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Testimonials</Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">FAQ</Link>
              </li>
              <li>
                <Link to="/quote" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Get a Quote</Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Our Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/services#weekly" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Weekly Cleaning</Link>
              </li>
              <li>
                <Link to="/services#biweekly" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Bi-Weekly Cleaning</Link>
              </li>
              <li>
                <Link to="/services#repairs" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Pool Repairs</Link>
              </li>
              <li>
                <Link to="/services#green" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Green to Clean</Link>
              </li>
              <li>
                <Link to="/services#rental" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">Short Term Rental Service</Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-orange-400">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 text-orange-400 mr-2 mt-0.5" />
                <span className="text-gray-300">Central Florida Service Area</span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 text-orange-400 mr-2" />
                <a href="tel:+18008194612" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">(800) 819-4612</a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 text-orange-400 mr-2" />
                <a href="mailto:clay@splashrightpoolcare.com" className="text-gray-300 hover:text-orange-400 transition-colors duration-200">clay@splashrightpoolcare.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-purple-800 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400">
              &copy; {new Date().getFullYear()} Splash Right Pool Care. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-orange-400 transition-colors duration-200 mr-4">Privacy Policy</Link>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-orange-400 transition-colors duration-200">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;